import script from "./StrategyUpsert.vue?vue&type=script&lang=ts&setup=true"
export * from "./StrategyUpsert.vue?vue&type=script&lang=ts&setup=true"

import "./StrategyUpsert.vue?vue&type=style&index=0&id=51477081&lang=scss"

const __exports__ = script;

export default __exports__